"use client";

import React from "react";
import { programsModuleTechniquesAcademy } from "../../../../shared/services";

import { message, Modal } from "antd";
const { confirm } = Modal;

export default function useDeleteProgramTechniques(
) {
  const [loading, setLoading] = React.useState(false);

  const showDeleteConfirm = (valId: number, val: string) => {
    if (!valId ) {
      message.error("Tecnica no valido");
      return;
    }

    confirm({
      title: `Estás seguro de borrar el tema con el id: ${valId}`,
      // icon: <ExclamationCircleOutlined />,
      content: `Una vez ejecutada esta acción no hay vuelta atrás, estás por borrar a "${val}", si deseas continuar dale click a "Borrar tecnica" en caso tal solo oprime en "Cancelar".`,
      okText: "Borrar tecnica",
      okType: "danger",
      cancelText: "Cancelar",
      async onOk() {
        setLoading(true);
        try {
          await programsModuleTechniquesAcademy.remove(valId).then((res)=>{
            message.success(`Se ha borrado con éxito la tecnica con id:${valId}`);
          })
        } catch (err: any) {
          message.error(`Error: ${err.message}`);
        } finally {
          setLoading(false);
        }
      },
      onCancel() {},
    });
  };

  return { showDeleteConfirm, loading };
}
